import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./MelbourneService.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Melbournebanner from "../Assets/Services/Adelaide-banner-img.png";
import WhoAreWe from "../Assets/Services/Melbourne/who-are-we-Melbourne-img.png";
import HouseCleaning from "../Assets/Services/House Cleaning.svg";
import CommercialCleaning from "../Assets/Services/Commercial Cleaning.svg";
import GutterCleaning from "../Assets/Services/Gutter Cleaning.svg";
import Roofcleaning from "../Assets/Services/Roof cleaning.svg";
import WindowCleaning from "../Assets/Services/Window Cleaning.svg";
import PressureCleaning from "../Assets/Services/Pressure Cleaning.svg";
import SolarCleaning from "../Assets/Services/Solar Cleaning.svg";
import NDIScleaning from "../Assets/Services/NDIS cleaning.svg";
import CarpetSteamCleaning from "../Assets/Services/Carpet Steam Cleaning.svg";
import OvenCleaning from "../Assets/Services/Oven Cleaning.svg";
import our_img from "../Assets/Services/our-img.png";
import our_icon_1 from "../Assets/Services/our-icon-1.svg";
import our_icon_2 from "../Assets/Services/our-icon-2.svg";
import our_icon_3 from "../Assets/Services/our-icon-3.svg";
import our_icon_4 from "../Assets/Services/our-icon-4.svg";
import GoogleReviews from "../Home/GoogleReviews";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaArrowRight, FaPhoneAlt } from "react-icons/fa";
import Google from "../Assets/Google.png";
import GoogleG from "../Assets/Google-G.png";
import verified from "../Assets/ti-verified.svg fill.png";

import api, { PUBLIC_BASE_URL , BASE_URL} from "../Api/api";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OpenCageAutocomplete from "../OpenCageAutocomplete";


const stats = [
  {
    img: our_icon_1,
    value: "1106",
    label: "Completed Excellence Services",
  },
  {
    img: our_icon_2,
    value: "22+",
    label: "Experienced Staff",
  },
  {
    img: our_icon_3,
    value: "950+",
    label: "Satisfied Residential Clients",
  },
  {
    img: our_icon_4,
    value: "120+",
    label: "Commercial Projects Completed",
  },
];

const MelbourneService = () => {
  const [city, setCity] = useState("Melbourne");

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const inputRef = useRef(null);

  useEffect(() => {
    if (!window.google) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["geocode"],
        componentRestrictions: { country: "au" }, // restrict to Australia
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("Selected place:", place);
      // You can also set the selected value to a state
    });
  }, []);


     const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("testimonials").then((res) => {
      setTestimonials(res.data.testimonials);
    });
  }, []);

 
   const [scrollIndex, setScrollIndex] = useState(0);
   const [visibleCards, setVisibleCards] = useState(3);
   const scrollRef = useRef();
   const CARD_WIDTH = 300 + 16; // width + margin
 
   useEffect(() => {
     const updateVisibleCards = () => {
       const width = window.innerWidth;
       if (width < 576) {
         setVisibleCards(1);
       } else if (width < 768) {
         setVisibleCards(1);
       } else if (width < 992) {
         setVisibleCards(2);
       } else {
         setVisibleCards(3);
       }
     };
 
     updateVisibleCards();
     window.addEventListener("resize", updateVisibleCards);
     return () => window.removeEventListener("resize", updateVisibleCards);
   }, []);
 
   const scroll = (direction) => {
     const maxIndex = Math.ceil(testimonials.length / visibleCards) - 1;
     let newIndex = scrollIndex;
 
     if (direction === "left") {
       newIndex = Math.max(0, scrollIndex - 1);
     } else if (direction === "right") {
       newIndex = Math.min(maxIndex, scrollIndex + 1);
     }
 
     setScrollIndex(newIndex);
 
     if (scrollRef.current) {
       scrollRef.current.style.transform = `translateX(-${
         newIndex * CARD_WIDTH * visibleCards
       }px)`;
     }
   };

  const renderStars = (count) =>
    Array.from({ length: count }, (_, i) => (
      <b key={i} className="fa-solid fa-star" style={{ color: "gold" }}>
        ★
      </b>
    ));


    const [reviewCount, setReviewCount] = useState(null);

  useEffect(() => {
    api
      .get("google-review-count")
      .then((res) => {
        if (res.data) {
          setReviewCount(res.data.review_count);
        }
      })
      .catch((err) => {
        console.error("Error fetching Google Review Count:", err);
      });
  }, []);

     const [heroData, setHeroData] = useState(null);

  useEffect(() => {
    api
      .get("melbourne-hero")
      .then((response) => setHeroData(response.data))
      .catch((error) => console.error("Error fetching hero data:", error));
  }, []);

    const [services, setServices] = useState([]);

useEffect(() => {
  api
    .get("servicesinadelaide") 
    .then((response) => {
      if (response.data.success) {
        setServices(response.data.services);
      }
    })
    .catch((error) => {
      console.error("Failed to fetch services:", error);
    });
}, []);

 const [achievementData, setAchievementData] = useState(null);

  useEffect(() => {
    api
      .get("achievements") // Adjust URL if needed
      .then((response) => {
        setAchievementData(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching achievements:", error);
      });
  }, []);

  const [data, setData] = useState(null);

  useEffect(() => {
    api
      .get("melbournewhoweare")
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.error("Failed to fetch who-we-are data", err));
  }, []);


      const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // success or error

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  try {
    const response = await api.post("/contact-submit", formData, {
      headers: { "Content-Type": "application/json" },
    });

    if (response.data.success) {
      toast.success("✅ Form submitted successfully!");

      // ✅ WhatsApp message send
      const phoneNumber = "61406958557"; // Replace with your WhatsApp number
      const message = encodeURIComponent(
        `New Lead from Melbourne Service Form Submission:\n
Name: ${formData.name}\n
Email: ${formData.email}\n
Phone: ${formData.phone}\n
Address: ${formData.address}\n
City: ${formData.city}\n
Message: ${formData.message}`
      );

      const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
      // window.open(whatsappLink, "_blank"); // opens WhatsApp with message

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        city: "",
        address: "",
        message: "",
        captcha: "",
      });
    } else {
      toast.error("❌ Submission failed. Please try again.");
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("❌ An error occurred. Please check the console.");
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div>
      <Header />

        <section
            className="hero-section position-relative d-flex align-items-center justify-content-center text-white text-center"
            style={{
              backgroundImage: `url(${PUBLIC_BASE_URL}${heroData?.image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "65vh",
            }}
          >
            <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"></div>
      
            <div className="container position-relative z-1">
              <h1 className="display-4 fw-bold text-shadow mb-3">
                {heroData?.title}
              </h1>
              <span>
                Home
                <Link
                  to="/melbourne-service"
                  className="text-decoration-none text-white"
                >
                  / Services
                </Link>
              </span>
            </div>
          </section>

     
    <section className="py-5 bg-light who-we-are-section">
      <div className="container">
        <div className="row align-items-center gy-4">
          {/* Left Content */}
          <div className="col-lg-6" data-aos="fade-right">
            <h2 className="fw-bold mb-4 display-6" style={{ color: "#001070" }}>
              {data?.heading}
            </h2>

            {/* Dynamic Description with Paragraphs */}
            <div
              className="text-muted fs-5 mb-4"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            ></div>

            <Link
              to="/free-quote"
              className="btn btn-outline-info d-inline-flex align-items-center gap-2"
              style={{ borderRadius: "30px" }}
            >
              GET FREE QUOTE <i className="fas fa-arrow-right"></i>
            </Link>
          </div>

          {/* Right Image */}
          <div className="col-lg-6 text-center" data-aos="fade-left">
            <img
              src={`${PUBLIC_BASE_URL}${data?.image}`}
              alt="Who we are"
              className="img-fluid rounded-4 shadow-lg animate-img"
            />
          </div>
        </div>
      </div>
    </section>
     

       <section className="py-5 service-section">
            <div className="container">
              <h2
                className="text-center fw-bold mb-5 section-heading"
                data-aos="fade-down"
              >
                Our Services In Melbourne 
              </h2>
      
              <div className="row g-4">
                {services.map((service, index) => (
                  <div
                    key={index}
                    className="col-12 col-sm-6 col-lg-3 d-flex"
                    data-aos="fade-up"
                    data-aos-delay={index * 100}
                  >
                    <div className="card h-100 service-card border-0 shadow w-100">
                      <div className="card-body d-flex flex-column">
                        <div className="icon-wrapper mb-3">
                          <img
                            src={`${BASE_URL}${service.icon}`}
                            
                            alt={service.title}
                            className="service-icon"
                          />
                        </div>
                        <h5 className="fw-bold">{service?.title}</h5>
                        <p className="text-muted flex-grow-1">
                          {service?.description}
                        </p>
                        <Link
                          to={service?.route}
                          className="view-more mt-2 align-self-start"
                        >
                          View more →
                        </Link>
      
                        <div className="row mt-3">
                          <div className="col-12 col-md-6 mb-2 mb-md-0">
                            <Link
                              to="/free-quote"
                              className="btn btn-outline-info btn-sm w-100 d-flex justify-content-center align-items-center gap-2"
                              style={{ borderRadius: "30px" }}
                            >
                              Get Free Quote <FaArrowRight />
                            </Link>
                          </div>
                          <div className="col-12 col-md-6">
                            <Link
                              to="tel:0406958557"
                              className="btn btn-outline-primary btn-sm w-100 d-flex justify-content-center align-items-center gap-2"
                              style={{ borderRadius: "30px" }}
                            >
                              Call Now <FaPhoneAlt />
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

<section className="achievements-section py-5">
  <div className="container">
    <div className="row align-items-center g-5">
      {/* LEFT CONTENT */}
      <div className="col-12 col-lg-6" data-aos="fade-right">
        <h2 className="fw-bold mb-3 display-6" style={{ color: "#001070" }}>
          {achievementData?.heading}
        </h2>
        <p className="mb-4 fs-5 text-muted">{achievementData?.description}</p>

        <div className="row g-3">
          {achievementData?.points.map((stat, index) => (
            <div
              className="col-12 col-sm-6"
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="stat-card d-flex align-items-center shadow-sm p-3 rounded">
                <div className="stat-icon-wrapper me-3">
                  <img
                    src={`${BASE_URL}${stat.icon}`}
                    alt="icon"
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
                <div>
                  <h3 className="mb-0">{stat.value}</h3>
                  <p className="mb-0">{stat.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="col-12 col-lg-6 text-center" data-aos="fade-left">
        <img
          src={`${BASE_URL}${achievementData?.image}`}
          alt="Achievements"
          className="img-fluid rounded-4 shadow-lg animate-img"
          style={{ maxHeight: "450px", objectFit: "cover" }}
        />
      </div>
    </div>
  </div>
</section>

      <section className="contact-section py-5">
        <div className="container">
          <div className="row g-5 align-items-stretch">
            {" "}
            {/* changed align-items-start to align-items-stretch */}
            {/* Left: Contact Form */}
              <div className="col-lg-6 d-flex">
              <form  onSubmit={handleSubmit} className="p-4 bg-light rounded shadow w-100 d-flex flex-column justify-content-between">
                
                  <p className="section-subtitle text-primary fw-bold">
                    — Get in touch
                  </p>
                  <h2 className="section-title mb-4">Reach Out to us!</h2>

                   <div className="mb-3 mt-5">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        required
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Phone"
                        required
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3 mt-5">
                      <select
                        className="form-select"
                        name="city"
                        required
                        value={formData.city}
                        onChange={handleChange}
                      >
                        <option value="">Select City</option>
                        <option value="Adelaide" selected>
                          {" "}
                          Adelaide
                        </option>
                        {/* <option value="Melbourne">Melbourne</option> */}
                      </select>
                    </div>
                    <div className="mb-3 mt-5">
                      {/* <input
                        // ref={inputRef}
                        type="text"
                        className="form-control"
                        placeholder="Address"
                        required
                        name="address"
                        value={formData.address || ""}
                        onChange={handleChange}
                      /> */}
                            <OpenCageAutocomplete
                            type="text"
                        className="form-control"
                        placeholder="Address"
                        required
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3 mt-5">
                      <textarea
                        className="form-control"
                        placeholder="Message (optional)"
                        rows="4"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <div className="mb-3 mt-5">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="What is 6 + 4?"
                        required
                        name="captcha"
                        value={formData.captcha}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button> */}

                    <button
                      type="submit"
                      className="btn btn-primary w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </button>

                    {/* Toast container for notifications */}
                    <ToastContainer position="top-right" autoClose={3000} />
              </form>
            </div>
            {/* Right: Stacked Maps */}
            <div className="col-lg-6 d-flex">
              <div className="w-100  d-flex flex-column justify-content-between">
                <h4 className="text-start mb-4" style={{ color: "#001070" }}>
                  📍 Explore Our Locations
                </h4>

                {/* Map Card */}
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden location-card h-100"
                  style={{ background: "#f8f9fa" }}
                >
                  <iframe
                    className="w-100"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.0871388961723!2d144.95738737524238!3d-37.76455493122626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65cad608dc30b%3A0x834fbb6421464695!2sVic%20Little%20Ln%2C%20Brunswick%20VIC%203056%2C%20Australia!5e0!3m2!1sen!2sin!4v1750149815947!5m2!1sen!2sin"
                    title="Melbourne Office"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    style={{ height: "800px", border: 0 }}
                  ></iframe>
                  <div className="p-3 mt-4">
                    <h5 className="text-dark fw-semibold mb-1">
                      🏢{" "}
                      <span style={{ color: "#001070" }}>Melbourne Office</span>
                    </h5>
                    <p className="mb-1 text-muted">📍 Brunswick, VIC 3056</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    <section className="testimonials-section">
  <div className="container">
    <div className="section-header text-center mb-4">
      <p className="subheading">— Testimonials</p>
      <h2>Client Testimonies: Experience with Our Cleaners</h2>
    </div>

    <div className="row">
      {/* Left Summary */}
      <div className="col-lg-3 col-md-4 mb-4 text-center review-summary">
        <p className="rating-label m-0 fw-bold fs-5">EXCELLENT</p>
        <div className="stars">{renderStars(5)}</div>
        <p>
          Based on{" "}
          <strong>{reviewCount !== null ? reviewCount : "..."}</strong> reviews
        </p>
        <img
          src={Google}
          alt="Google"
          style={{ width: "100px", marginTop: "-10px" }}
        />
      </div>

      {/* Testimonials Scrollable */}
      <div className="col-lg-9 col-md-8 position-relative testimonial-scroll-wrapper">
        <div className="testimonial-scroll d-flex" ref={scrollRef}>
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="testimonial-card p-3 mx-2 bg-white rounded shadow"
            >
              <div className="card-header d-flex align-items-center mb-2">
                {item.avatar ? (
                  <img
                    src={`${PUBLIC_BASE_URL}${item.avatar}`}
                    className="avatar-img me-2 rounded-circle"
                    alt={item.name}
                    style={{ width: 40, height: 40 }}
                  />
                ) : (
                  <div className="avatar me-2">{item.name?.charAt(0)}</div>
                )}
                <div>
                  <h5 className="mb-0">{item.name}</h5>
                  <small>{item.date}</small>
                </div>
                <img
                  src={`${PUBLIC_BASE_URL}${item.platform}`}
                  alt="Platform"
                  style={{ width: 16, marginLeft: "auto" }}
                />
              </div>

              <div className="rating mb-2">
                {renderStars(item.rating)}
                {item.verified && (
                  <img
                    src={`${PUBLIC_BASE_URL}${item.verified}`}
                    alt="verified"
                    style={{
                      width: 16,
                      marginLeft: "6px",
                      verticalAlign: "middle",
                    }}
                  />
                )}
              </div>

              <p className="comment-truncate m-0">{item.comment}</p>
            </div>
          ))}
        </div>

        {/* Arrow Controls */}
        <div className="d-flex justify-content-center gap-2 scroll-controls">
          <button
            onClick={() => scroll("left")}
            className="scroll-arrow left-arrow"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={() => scroll("right")}
            className="scroll-arrow right-arrow"
          >
            <FaChevronRight />
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

      <Footer />
    </div>
  );
};

export default MelbourneService;
